import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { Button, message, Popconfirm, Popover, Space, Tag } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  cancelPatientinsurancePolicy,
  deletePatientinsurancePolicy,
  getPatientInsurancePolicies,
} from '../../network/PatientInsurancePolicy';
import { queryKeys } from '../../services/react-query/queryKeys';
import { TiCancel } from 'react-icons/ti';
import StatusTag from '../../hooks/StatusHook';

const PatientInsurancePolicy = ({ t }) => {
  const client = useQueryClient();
  const [cancel, setCancel] = useState(false);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const { currentLang } = useSelector((state) => state.user);
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getPatientInsurancePolicies],
    queryFn: () => getPatientInsurancePolicies(),
    keepPreviousData: true,
  });

  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) =>
        cancel
          ? cancelPatientinsurancePolicy(id)
          : deletePatientinsurancePolicy(id),
      onSuccess: (data) => {
        // console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        client.invalidateQueries({
          queryKey: [queryKeys.getPatientInsurancePolicies],
        });
        // message.success(data?.message?.message);
        message.success('Deleted successfully');
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const columns = [
    {
      title:
        currentLang === 'en'
          ? 'Patient Insurance Policy Name'
          : 'اسم بوليصة تأمين المريض',
      dataIndex: 'name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.name).toLowerCase();
        const searchValue = value.toLowerCase();
        return name.includes(searchValue);
      },
    },
    {
      title: currentLang === 'en' ? 'Policy Number' : 'رقم السياسة',
      dataIndex: 'policy_number',
    },
    {
      title:
        currentLang === 'en' ? 'Policy Expiry Date' : 'تاريخ انتهاء السياسة',
      dataIndex: 'policy_expiry_date',
    },
    {
      title: currentLang === 'en' ? 'Insurance Payor' : 'دافع التأمين',
      dataIndex: 'insurance_payor',
    },
    {
      title: currentLang === 'en' ? 'Insurance Plan' : 'خطة التأمين',
      dataIndex: 'insurance_plan',
    },
    {
      title: currentLang === 'en' ? 'Patient' : 'المريض',
      dataIndex: 'patient_name',
    },
    {
      title: currentLang === 'en' ? 'Status' : 'الحالة',
      dataIndex: 'docstatus',
      render: (status) => <StatusTag status={status} />,
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      // width: 150,
      render: (text, record) => {
        // console.log('record:', record);
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              icon={<MdModeEditOutline />}
              onClick={() => {
                navigate(`/patient_insurance_policy/edit/${record.name}`);
              }}
            />
            <Popconfirm
              title={t.DeletethePatientInsurancePolicy}
              description={t.areYouSure}
              onConfirm={() => {
                setCancel(false);
                handleRemove.mutate(record?.name);
              }}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm>
            {record?.docstatus !== 2 && (
              <Popconfirm
                title={t.cancelPatientInsurancePolicy}
                description={t.areYouSure}
                onConfirm={() => {
                  setCancel(true);
                  handleRemove.mutate(record?.name);
                }}
                // onCancel={cancel}
                okText={t.yes}
                cancelText={t.no}
              >
                <Button
                  size="small"
                  type="primary"
                  // danger
                  style={{ background: 'red' }}
                  icon={<TiCancel />}
                />
              </Popconfirm>
            )}
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => ({
    key: index,
    ...item,
  }));
  return (
    <div className="patient-insurance">
      <Heading
        title={t.Insurances}
        subTitle={t.PatientInsurancePolicy}
        path="/"
      />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn={t.addPatient}
        titleBtn={t.AddPatientInsurancePolicy}
        Placeholder={t.SearchPatientInsurancePolicy}
        pathBtn="/patient_insurance_policy/add"
      />
    </div>
  );
};

export default PatientInsurancePolicy;
